import React from "react";
import ProgramPage from "../../components/ProgramPage";

export default function PurposeInTheProcess() {
    return (
        <ProgramPage
            eyebrow="A Program of The Gift of Kindness"
            title="Purpose in the Process"
            subtitle="Finding meaning in every season."
            tagline="The struggle is not the story. It's the setup."
            hero_image="https://images.unsplash.com/photo-1519834584171-c47ce7e0a687?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            intro="Purpose in the Process is for anyone in the middle — between prayer and promise, between wilderness and destiny — helping them see that God is doing something in the waiting."
            body_paragraphs={[
                "Some of the deepest work happens before anyone claps for you. Purpose in the Process is a season-long journey that helps women, men, and young adults name what they're walking through and hear what God is walking them toward.",
                "Through group cohorts, guided reflection, mentorship, and honest storytelling, participants learn to trade shame for testimony, comparison for calling, and hurry for holy pace.",
                "You don't have to have it figured out to belong here. You just have to be willing to grow. If you're in a season that doesn't make sense yet, you're exactly where this program was built for.",
            ]}
            pillars={[
                { t: "Cohort Sessions", b: "Small, safe groups that meet weekly — real conversation, no performance, no perfect-Christian pretending." },
                { t: "One-to-One Mentorship", b: "Paired with a mentor who has walked a similar season and can say the words you need to hear." },
                { t: "Reflection Toolkit", b: "Guided journal prompts, scripture, and audio devotionals to work through between sessions." },
            ]}
            verse={{
                text: "And we know that in all things God works for the good of those who love him, who have been called according to his purpose.",
                attribution: "Romans 8:28",
            }}
            cta_text="Apply for a Cohort"
        />
    );
}
